
























import Vue from "vue";
import { mapGetters } from "vuex";

export default Vue.extend({
    name: "ClassifiedsEmptyState",

    computed: {
        ...mapGetters({
            isMasquerading: "UserModule/isMasquerading"
        })
    }
});
